"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _material = require("@mui/material");

var _Link = require("../Link");

var _utilities = require("../../utilities");

var _jsxRuntime = require("react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StyledLink = (0, _material.styled)(_Link.Link)(function (_ref) {
  var theme = _ref.theme;
  return {
    "&:focus": {
      top: theme.spacing(2)
    },
    backgroundColor: theme.palette.background.paper,
    left: theme.spacing(3),
    padding: theme.spacing(2),
    position: "fixed",
    top: "-".concat(theme.spacing(8)),
    zIndex: theme.zIndex.tooltip + 1
  };
});
/**
 * The WCAG 2.0 Level A guidelines require [Bypass Blocks (2.4.1)](https://www.w3.org/TR/UNDERSTANDING-WCAG20/navigation-mechanisms-skip.html) in place throughout document navigation.
 * Our `SkipLink` should be placed before any repeated navigation block, with an `href` matching the ID of the next available block of content (eg. Main content) which is prepared to receive focus by using the `tabindex="-1"` attribute.
 * For more information on skip links, refer to [WebAIM's article on Skip Navigation Links](https://webaim.org/techniques/skipnav/).
 *
 * At its core, the SkipLink component renders an HTML `a` and will accept any attributes available to that element.
 * [See MDN's documentation on attributes accepted by `a`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#Attributes).
 **/

function SkipLink() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    children: null,
    href: "#".concat(_utilities.MAIN_CONTENT_ID)
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLink, _objectSpread({}, props));
}

var _default = SkipLink;
exports.default = _default;